import Main from '@/components/common/main'

export default [
    {
        path: '/member',
        component: Main,
        children: [
            {
                path: 'list',
                component: () => import('@/views/member/list.vue')
            }
        ]
    },
    {
        path: '/memberinvite',
        component: Main,
        children: [
            {
                path: 'list',
                component: () => import('@/views/memberinvite/list.vue')
            }
        ]
    },
    {
        path: '/memberpointlog',
        component: Main,
        children: [
            {
                path: 'list',
                component: () => import('@/views/memberpointlog/list1.vue')
            }
        ]
    },
    {
        path: '/membernotice',
        component: Main,
        children: [
            {
                path: 'list',
                component: () => import('@/views/membernotice/list.vue')
            }
        ]
    },
    {
        path: '/carinfo',
        component: Main,
        children: [
            {
                path: 'list',
                component: () => import('@/views/carinfo/list.vue')
            }
        ]
    },
    {
        path: '/carreport',
        component: Main,
        children: [
            {
                path: 'list',
                component: () => import('@/views/carreport/list.vue')
            },
            {
                path: 'listh',
                component: () => import('@/views/carreporth/list.vue')
            }
        ]
    },
    {
        path: '/notice',
        component: Main,
        children: [
            {
                path: 'list',
                component: () => import('@/views/notice/list.vue')
            }
        ]
    },
    {
        path: '/cardaily',
        component: Main,
        children: [
            {
                path: 'list',
                component: () => import('@/views/cardaily/list.vue')
            }
        ]
    },
    {
        path: '/carweek',
        component: Main,
        children: [
            {
                path: 'list',
                component: () => import('@/views/carweek/list.vue')
            }
        ]
    },
    {
        path: '/carmonth',
        component: Main,
        children: [
            {
                path: 'list',
                component: () => import('@/views/carmonth/list.vue')
            }
        ]
    },
    {
        path: '/caryear',
        component: Main,
        children: [
            {
                path: 'list',
                component: () => import('@/views/caryear/list.vue')
            }
        ]
    },
    {
        path: '/delivery',
        component: Main,
        children: [
            {
                path: 'list',
                component: () => import('@/views/delivery/list.vue')
            }
        ]
    },
    {
        path: '/deliveryorder',
        component: Main,
        children: [
            {
                path: 'list',
                component: () => import('@/views/deliveryorder/list.vue')
            }
        ]
    },
    {
        path: '/deliveryrecord',
        component: Main,
        children: [
            {
                path: 'list',
                component: () => import('@/views/deliveryrecord/list.vue')
            }
        ]
    },
    {
        path: '/deliverydayconfig',
        component: Main,
        children: [
            {
                path: 'list',
                component: () => import('@/views/deliverydayconfig/list.vue')
            }
        ]
    },
    {
        path: '/batteryhealth',
        component: Main,
        children: [
            {
                path: 'list',
                component: () => import('@/views/batteryhealth/list.vue')
            }
        ]
    },
    {
        path: '/batteryhealthassess',
        component: Main,
        children: [
            {
                path: 'list',
                component: () => import('@/views/batteryhealthassess/list.vue')
            }
        ]
    },
    {
        path: '/deliverychange',
        component: Main,
        children: [
            {
                path: 'list',
                component: () => import('@/views/deliverychange/list.vue')
            }
        ]
    },
    {
        path: '/feedback',
        component: Main,
        children: [
            {
                path: 'list',
                component: () => import('@/views/feedback/list.vue')
            }
        ]
    },
    {
        path: '/record',
        component: Main,
        children: [
            {
                path: 'list',
                component: () => import('@/views/record/list.vue')
            }
        ]
    },
    {
        path: '/hostlist',
        component: Main,
        children: [
            {
                path: 'list',
                component: () => import('@/views/hostlist/list.vue')
            }
        ]
    },
    {
        path: '/appversion',
        component: Main,
        children: [
            {
                path: 'list',
                component: () => import('@/views/appversion/list.vue')
            }
        ]
    },
    {
        path: '/appversionapple',
        component: Main,
        children: [
            {
                path: 'list',
                component: () => import('@/views/appversionapple/list.vue')
            }
        ]
    },
    {
        path: '/appuidlog',
        component: Main,
        children: [
            {
                path: 'list',
                component: () => import('@/views/appuidlog/list.vue')
            }
        ]
    },
    {
        path: '/banner',
        component: Main,
        children: [
            {
                path: 'list',
                component: () => import('@/views/banner/list.vue')
            }
        ]
    },
    {
        path: '/goodscate',
        component: Main,
        children: [
            {
                path: 'list',
                component: () => import('@/views/goodscate/list.vue')
            }
        ]
    },
    {
        path: '/goods',
        component: Main,
        children: [
            {
                path: 'list',
                component: () => import('@/views/goods/list.vue')
            }
        ]
    },
    {
        path: '/order',
        component: Main,
        children: [
            {
                path: 'list',
                component: () => import('@/views/order/list.vue')
            }
        ]
    },
    {
        path: '/promotionmember',
        component: Main,
        children: [
            {
                path: 'list',
                component: () => import('@/views/promotionmember/list.vue')
            }
        ]
    },
    {
        path: '/promotiongoods',
        component: Main,
        children: [
            {
                path: 'list',
                component: () => import('@/views/promotiongoods/list.vue')
            }
        ]
    },
    {
        path: '/promotionorder',
        component: Main,
        children: [
            {
                path: 'list',
                component: () => import('@/views/promotionorder/list.vue')
            }
        ]
    },
    {
        path: '/promotionsettled',
        component: Main,
        children: [
            {
                path: 'list',
                component: () => import('@/views/promotionsettled/list.vue')
            }
        ]
    },
    {
        path: '/goodsjd',
        component: Main,
        children: [
            {
                path: 'list',
                component: () => import('@/views/goodsjd/list.vue')
            }
        ]
    },
    {
        path: '/shop',
        component: Main,
        children: [
            {
                path: 'list',
                component: () => import('@/views/shop/list.vue')
            }
        ]
    },
    {
        path: '/shopsend',
        component: Main,
        children: [
            {
                path: 'list',
                component: () => import('@/views/shopsend/list.vue')
            }
        ]
    },
    {
        path: '/moment',
        component: Main,
        children: [
            {
                path: 'list',
                component: () => import('@/views/moment/list.vue')
            }
        ]
    },
    {
        path: '/momentcate',
        component: Main,
        children: [
            {
                path: 'list',
                component: () => import('@/views/momentcate/list.vue')
            }
        ]
    },
    {
        path: '/momenttopic',
        component: Main,
        children: [
            {
                path: 'list',
                component: () => import('@/views/momenttopic/list.vue')
            }
        ]
    },
    {
        path: '/momentad',
        component: Main,
        children: [
            {
                path: 'list',
                component: () => import('@/views/momentad/list.vue')
            }
        ]
    },
    {
        path: '/simulateline',
        component: Main,
        children: [
            {
                path: 'list',
                component: () => import('@/views/simulateline/list.vue')
            }
        ]
    },
    {
        path: '/',
        component: Main,
        children: [
            {
                path: 'list',
                component: () => import('@/views/weightdata/list.vue')
            }
        ]
    },
    {
        path: '/tools',
        component: Main,
        children: [
            {
                path: 'action',
                component: () => import('@/views/carinfo/tools.vue')
            }
        ]
    },
    {
        path: '/chargedate',
        component: Main,
        children: [
            {
                path: 'list',
                component: () => import('@/views/chargedate/list.vue')
            }
        ]
    },
    {
        path: '/goodssearchlog',
        component: Main,
        children: [
            {
                path: 'list',
                component: () => import('@/views/goodssearchlog/list.vue')
            }
        ]
    },
    {
        path: '/raffle',
        component: Main,
        children: [
            {
                path: 'list',
                component: () => import('@/views/raffle/list.vue')
            }
        ]
    },
    {
        path: '/carversion',
        component: Main,
        children: [
            {
                path: 'list',
                component: () => import('@/views/carversion/list.vue')
            }
        ]
    },
    {
        path: '/kitlog',
        component: Main,
        children: [
            {
                path: 'list',
                component: () => import('@/views/kitlog/list.vue')
            }
        ]
    },
    {
        path: '/weightdata',
        component: Main,
        children: [
            {
                path: 'list',
                component: () => import('@/views/weightdata/list.vue')
            }
        ]
    },
    {
        path: '/testdriverecommend',
        component: Main,
        children: [
            {
                path: 'list',
                component: () => import('@/views/testdriverecommend/list.vue')
            }
        ]
    },
    {
        path: '/batteryfeedback',
        component: Main,
        children: [
            {
                path: 'list',
                component: () => import('@/views/batteryfeedback/list.vue')
            }
        ]
    },
    {
        path: '/mdhz',
        component: Main,
        children: [
            {
                path: 'list',
                component: () => import('@/views/mdhz/list.vue')
            }
        ]
    },
    {
        path: '/mdhzlog',
        component: Main,
        children: [
            {
                path: 'list',
                component: () => import('@/views/mdhzlog/list.vue')
            }
        ]
    },
    {
        path: '/mdscreen',
        component: Main,
        children: [
            {
                path: 'list',
                component: () => import('@/views/mdscreen/list.vue')
            }
        ]
    },
    {
        path: '/mdscreenversion',
        component: Main,
        children: [
            {
                path: 'list',
                component: () => import('@/views/mdscreenversion/list.vue')
            }
        ]
    },
    {
        path: '/mdscreenheart',
        component: Main,
        children: [
            {
                path: 'list',
                component: () => import('@/views/mdscreenheart/list.vue')
            }
        ]
    },
    {
        path: '/cardetectionlog',
        component: Main,
        children: [
            {
                path: 'list',
                component: () => import('@/views/cardetectionlog/list.vue')
            }
        ]
    },
]